"use client";

import { useTransition } from "react";

import { Button } from "~/components/ui/button";
import { type ProductId } from "~/lib/tours";
import { useCart, type TourCartLine } from "~/lib/use-cart";

export function RemoveCartLine({
  cartLine: { lineItem, type },
}: {
  cartLine: TourCartLine;
}) {
  const { removeTourCartLine, addTourCartLine } = useCart();
  const [isPending, startTransition] = useTransition();
  let productId: ProductId;
  if (type === "bokun") {
    productId = { type: "bokun", id: lineItem.experienceId };
  } else {
    productId = { type: "linktivity", id: lineItem.activityId };
  }
  return (
    <Button
      variant="link"
      className="text-prune-500 w-full rounded-full text-sm font-medium"
      disabled={isPending}
      onClick={(event) => {
        event.preventDefault();
        startTransition(async () => {
          void removeTourCartLine.mutateAsync({
            lineItemId: lineItem.id,
            productId,
          });
          addTourCartLine.reset();
        });
      }}
    >
      {isPending ? "Removing" : "Remove from cart"}
    </Button>
  );
}
